// Feature-scoped query-key factory for the Story List vertical.
// Params are kept as objects in the key so `queryClient.setQueryData` /
// `invalidateQueries` can target exact matches, and broad prefix matches
// (e.g. `[...all, 'storyFolders']`) sweep every param variant.

export type StoryFoldersKeyParams = {
  entityId: number;
  displayPublicationTab: boolean;
};

export type StoriesKeyParams = {
  entityId: number;
  page: number;
  perPage?: number;
  sort?: string;
  title?: string;
  storyVisibility?: string;
  ogId?: number;
  shouldFilterByUser?: boolean;
  folderId?: string;
  showAllStoriesForSelectedFolder?: boolean;
};

export type PublicationFoldersTreeKeyParams = {
  entityId: number;
};

export type FoldersStoryCountKeyParams = {
  folderIds: string[];
};

export type FoldersAndSubFoldersStoryCountKeyParams = {
  entityId: number;
  folderId: string;
};

export type TemplatesKeyParams = {
  isOpenGovAdmin: boolean;
  entityId: number;
  page: number;
  perPage?: number;
  sort?: string;
  title?: string;
  shouldFilterByUser?: boolean;
  ogId?: number;
};

export const storyListQueryKeys = {
  all: ['storyList'] as const,
  storyFolders: (params: StoryFoldersKeyParams) =>
    [...storyListQueryKeys.all, 'storyFolders', params] as const,
  stories: (params: StoriesKeyParams) =>
    [...storyListQueryKeys.all, 'stories', params] as const,
  publicationFoldersTree: (params: PublicationFoldersTreeKeyParams) =>
    [...storyListQueryKeys.all, 'publicationFoldersTree', params] as const,
  foldersStoryCount: (params: FoldersStoryCountKeyParams) =>
    [...storyListQueryKeys.all, 'foldersStoryCount', params] as const,
  foldersAndSubFoldersStoryCount: (params: FoldersAndSubFoldersStoryCountKeyParams) =>
    [...storyListQueryKeys.all, 'foldersAndSubFoldersStoryCount', params] as const,
  templates: (params: TemplatesKeyParams) =>
    [...storyListQueryKeys.all, 'templates', params] as const,
};
